(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hcJxY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c866e3586ec5d16c$export$71511d61b312f219; });
function $c866e3586ec5d16c$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});

parcelRegister("kpulp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $edbdae32eb1590d9$export$71511d61b312f219; });

var $hcJxY = parcelRequire("hcJxY");
function $edbdae32eb1590d9$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $hcJxY._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $hcJxY._)(o, minLen);
}

});


var $hcJxY = parcelRequire("hcJxY");
function $73fbfb596f5a9697$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $hcJxY._)(arr);
}


function $64ea1ca729e27e92$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $4023cf3d82eed174$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



var $kpulp = parcelRequire("kpulp");
function $effd919f54eede65$export$71511d61b312f219(arr) {
    return (0, $73fbfb596f5a9697$export$71511d61b312f219)(arr) || (0, $64ea1ca729e27e92$export$71511d61b312f219)(arr) || (0, $kpulp._)(arr) || (0, $4023cf3d82eed174$export$71511d61b312f219)();
}


/**
 * Listing Offres d'Emploi – InRecruiting
 * Filtrage, rendu et modale gérés entièrement côté client.
 * Les données sont injectées via wp_localize_script (jobsData.jobs).
 */ (function() {
    "use strict";
    document.addEventListener("DOMContentLoaded", function() {
        /** @type {Array} */ var allJobs = typeof jobsData !== "undefined" && jobsData.jobs ? jobsData.jobs : [];
        // ---------- Éléments DOM ----------
        var grid = document.getElementById("jobs-grid");
        var countEl = document.getElementById("jobs-count");
        var noResults = document.getElementById("jobs-no-results");
        var selContract = document.getElementById("jobs-filter-contract");
        var selFunction = document.getElementById("jobs-filter-function");
        var btnReset = document.getElementById("jobs-filter-reset");
        // Modale
        var overlay = document.getElementById("jobs-modal-overlay");
        var closeBtn = document.getElementById("jobs-modal-close");
        if (!grid || !allJobs.length) {
            if (grid) grid.innerHTML = '<p class="text-[#7a7f8b] col-span-2 text-center py-10">Aucune offre disponible pour le moment.</p>';
            return;
        }
        // ---------- Helpers ----------
        function esc(str) {
            if (!str) return "";
            return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
        }
        function unique(arr) {
            return (0, $effd919f54eede65$export$71511d61b312f219)(new Set(arr.filter(Boolean))).sort();
        }
        function formatDate(raw) {
            if (!raw) return "";
            // Format attendu : "19-02-2026 (12:31)"
            var match = raw.match(/(\d{2})-(\d{2})-(\d{4})/);
            if (match) return match[3] + "-" + match[2] + "-" + match[1];
            return raw;
        }
        function formatDisplayDate(raw) {
            if (!raw) return "";
            var match = raw.match(/(\d{2})-(\d{2})-(\d{4})/);
            if (match) return match[1] + "/" + match[2] + "/" + match[3];
            return raw;
        }
        // ---------- Peupler les filtres ----------
        function populateSelect(select, values, placeholder) {
            while(select.options.length > 1)select.remove(1);
            values.forEach(function(v) {
                var opt = document.createElement("option");
                opt.value = v;
                opt.textContent = v;
                select.appendChild(opt);
            });
        }
        var contracts = unique(allJobs.map(function(j) {
            return j.contract_type;
        }));
        var functions = unique(allJobs.map(function(j) {
            return j["function"];
        }));
        populateSelect(selContract, contracts, "Tous les contrats");
        populateSelect(selFunction, functions, "Toutes les fonctions");
        // ---------- Rendu d'une carte ----------
        function renderCard(job) {
            var logoHtml = job.logo ? `<img src="${esc(job.logo)}" alt="${esc(job.company)}" class="h-[45px] w-auto object-contain max-w-[90px] shrink-0" loading="lazy" />` : "";
            return `
        <article class="bg-white border border-[rgba(116,140,151,0.2)] rounded-[2px] p-3.5 sm:p-5 lg:p-[30px] flex flex-col gap-3.5 sm:gap-5 lg:gap-[28px] hover:shadow-md transition-shadow">
          <div class="flex items-center justify-between gap-[20px]">
            <h3 class="text-[#284548] text-xl lg:text-[22px] font-normal leading-[1.3] tracking-[-0.44px] flex-1">${esc(job.title)}</h3>
            ${logoHtml}
          </div>
          <div class="flex flex-wrap gap-x-5 gap-y-2">
            ${job.contract_type ? `
            <span class="flex items-center gap-[7px] text-[#284548] text-base leading-[1.5] tracking-[-0.32px]">
                     <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0V13H4.875V10.3102L5.89317 9.90037C6.25636 9.75417 6.63027 9.62959 7.01339 9.52813C6.68904 9.05109 6.49946 8.47503 6.49946 7.85471C6.49946 6.92716 6.92331 6.09857 7.58788 5.55208H2.16667V4.46875H8.125V5.19978C8.5313 4.99212 8.99156 4.875 9.47917 4.875C9.96677 4.875 10.427 4.99212 10.8333 5.19977V3.5673L7.26603 0H0ZM5.41667 8.26042H2.16667V7.17708H5.41667V8.26042ZM7.58279 7.85471C7.58279 6.80734 8.43185 5.95833 9.47917 5.95833C10.5265 5.95833 11.3755 6.80734 11.3755 7.85471C11.3755 8.90202 10.5265 9.75108 9.47917 9.75108C8.43185 9.75108 7.58279 8.90202 7.58279 7.85471ZM5.95833 13V11.042L6.29774 10.9053C7.28146 10.5094 8.35559 10.2917 9.47917 10.2917C10.6027 10.2917 11.6769 10.5094 12.6606 10.9053L13 11.042V13H5.95833Z" fill="#EBEEEF" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0V13H4.875V10.3102L5.89317 9.90037C6.25636 9.75417 6.63027 9.62959 7.01339 9.52813C6.68904 9.05109 6.49946 8.47503 6.49946 7.85471C6.49946 6.92716 6.92331 6.09857 7.58788 5.55208H2.16667V4.46875H8.125V5.19978C8.5313 4.99212 8.99156 4.875 9.47917 4.875C9.96677 4.875 10.427 4.99212 10.8333 5.19977V3.5673L7.26603 0H0ZM5.41667 8.26042H2.16667V7.17708H5.41667V8.26042ZM7.58279 7.85471C7.58279 6.80734 8.43185 5.95833 9.47917 5.95833C10.5265 5.95833 11.3755 6.80734 11.3755 7.85471C11.3755 8.90202 10.5265 9.75108 9.47917 9.75108C8.43185 9.75108 7.58279 8.90202 7.58279 7.85471ZM5.95833 13V11.042L6.29774 10.9053C7.28146 10.5094 8.35559 10.2917 9.47917 10.2917C10.6027 10.2917 11.6769 10.5094 12.6606 10.9053L13 11.042V13H5.95833Z" fill="#189D95" />
                </svg>
              ${esc(job.contract_type)}
            </span>` : ""}
            ${job.location ? `
            <span class="flex items-center gap-[7px] text-[#284548] text-base leading-[1.5] tracking-[-0.32px]">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="13" viewBox="0 0 11 13" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.41667 13L5.09167 12.7563L5.09004 12.7551L5.08668 12.7525L5.07471 12.7434C5.06447 12.7357 5.04974 12.7244 5.03084 12.7098C4.99303 12.6806 4.93843 12.6379 4.86942 12.5829C4.73151 12.4729 4.53575 12.3131 4.3015 12.1113C3.83373 11.7085 3.20836 11.1354 2.58115 10.456C1.95555 9.77822 1.31739 8.98311 0.833089 8.13562C0.351352 7.29257 0 6.35971 0 5.41667C0 2.42512 2.42512 0 5.41667 0C8.40818 0 10.8333 2.42512 10.8333 5.41667C10.8333 6.35971 10.482 7.29257 10.0002 8.13562C9.51595 8.98311 8.87781 9.77822 8.25218 10.456C7.62499 11.1354 6.99958 11.7085 6.53185 12.1113C6.29758 12.3131 6.10182 12.4729 5.96391 12.5829C5.8949 12.6379 5.8403 12.6806 5.8025 12.7098C5.78359 12.7244 5.76886 12.7357 5.75862 12.7434L5.74665 12.7525L5.74329 12.7551L5.74167 12.7563L5.41667 13ZM4.33333 6.36458H6.5V4.19792H4.33333V6.36458Z" fill="#EBEEEF" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.41667 13L5.09167 12.7563L5.09004 12.7551L5.08668 12.7525L5.07471 12.7434C5.06447 12.7357 5.04974 12.7244 5.03084 12.7098C4.99303 12.6806 4.93843 12.6379 4.86942 12.5829C4.73151 12.4729 4.53575 12.3131 4.3015 12.1113C3.83373 11.7085 3.20836 11.1354 2.58115 10.456C1.95555 9.77822 1.31739 8.98311 0.833089 8.13562C0.351352 7.29257 0 6.35971 0 5.41667C0 2.42512 2.42512 0 5.41667 0C8.40818 0 10.8333 2.42512 10.8333 5.41667C10.8333 6.35971 10.482 7.29257 10.0002 8.13562C9.51595 8.98311 8.87781 9.77822 8.25218 10.456C7.62499 11.1354 6.99958 11.7085 6.53185 12.1113C6.29758 12.3131 6.10182 12.4729 5.96391 12.5829C5.8949 12.6379 5.8403 12.6806 5.8025 12.7098C5.78359 12.7244 5.76886 12.7357 5.75862 12.7434L5.74665 12.7525L5.74329 12.7551L5.74167 12.7563L5.41667 13ZM4.33333 6.36458H6.5V4.19792H4.33333V6.36458Z" fill="#189D95" />
                </svg>
              ${esc(job.location)}
            </span>` : ""}
            ${job.company ? `
            <span class="flex items-center gap-[7px] text-[#284548] text-base leading-[1.5] tracking-[-0.32px]">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.45455 0H0V13H4.13636V10.0455H5.31818V13H9.45455V0ZM2.65909 3.84091V2.65909H3.84091V3.84091H2.65909ZM2.65909 6.20455V5.02273H3.84091V6.20455H2.65909ZM2.65909 7.38636V8.56818H3.84091V7.38636H2.65909ZM5.61364 6.20455V5.02273H6.79545V6.20455H5.61364ZM5.61364 2.65909V3.84091H6.79545V2.65909H5.61364ZM5.61364 8.56818V7.38636H6.79545V8.56818H5.61364ZM10.6364 4.72727H13V13H10.6364V4.72727Z" fill="#EBEEEF" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.45455 0H0V13H4.13636V10.0455H5.31818V13H9.45455V0ZM2.65909 3.84091V2.65909H3.84091V3.84091H2.65909ZM2.65909 6.20455V5.02273H3.84091V6.20455H2.65909ZM2.65909 7.38636V8.56818H3.84091V7.38636H2.65909ZM5.61364 6.20455V5.02273H6.79545V6.20455H5.61364ZM5.61364 2.65909V3.84091H6.79545V2.65909H5.61364ZM5.61364 8.56818V7.38636H6.79545V8.56818H5.61364ZM10.6364 4.72727H13V13H10.6364V4.72727Z" fill="#189D95" />
                </svg>
              ${esc(job.company)}
            </span>` : ""}
            ${job["function"] ? `
            <span class="flex items-center gap-[7px] text-[#284548] text-base leading-[1.5] tracking-[-0.32px]">
            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="13" viewBox="0 0 11 13" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8321 0H0V13L5.41606 9.83464L10.8321 13V0Z" fill="#EBEEEF" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8321 0H0V13L5.41606 9.83464L10.8321 13V0Z" fill="#189D95" />
                </svg>
              ${esc(job["function"])}
            </span>` : ""}
          </div>
          <div class="flex items-center gap-5 flex-wrap justify-center mt-auto">
           <button
            type="button"
            class="jobs-read-more flex items-center gap-[10px] text-[#189d95] text-base font-bold underline underline-offset-2 hover:opacity-80 transition-opacity  lg:w-[144px]"
            data-job-id="${esc(job.id)}">
                Lire la suite<span class="sr-only"> : ${esc(job.title)}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6.97952 14.7702L12.746 8.87027H0V7.13087L12.746 7.13087L6.97952 1.22981L8.18152 0L16 8.00057L8.18152 16L6.97952 14.7702Z" fill="#189D95"/>
            </svg>
            </button>
            <a href="${esc(job.url)}"
              target="_blank"
              rel="noopener noreferrer"
              class="flex items-center justify-center bg-[#189d95] text-white text-base font-bold px-[25px] py-[14px] rounded-[2px] w-[144px] hover:opacity-90 transition-opacity whitespace-nowrap ">
              Postuler
            </a>
          </div>
        </article>`;
        }
        // ---------- Rendu de la grille ----------
        function renderGrid(jobs) {
            if (!jobs.length) {
                grid.innerHTML = "";
                noResults.classList.remove("hidden");
                countEl.classList.add("hidden");
                return;
            }
            noResults.classList.add("hidden");
            grid.innerHTML = jobs.map(renderCard).join("");
            countEl.textContent = jobs.length + " offre" + (jobs.length > 1 ? "s" : "") + " disponible" + (jobs.length > 1 ? "s" : "");
            countEl.classList.remove("hidden");
            // Attacher les listeners "Lire la suite"
            grid.querySelectorAll(".jobs-read-more").forEach(function(btn) {
                btn.addEventListener("click", function() {
                    var jobId = btn.dataset.jobId;
                    var job = allJobs.find(function(j) {
                        return String(j.id) === String(jobId);
                    });
                    if (job) openModal(job);
                });
            });
        }
        // ---------- Filtrage ----------
        function getFilteredJobs() {
            var contractVal = selContract.value;
            var functionVal = selFunction.value;
            return allJobs.filter(function(j) {
                var matchContract = !contractVal || j.contract_type === contractVal;
                var matchFunction = !functionVal || j["function"] === functionVal;
                return matchContract && matchFunction;
            });
        }
        btnReset.addEventListener("click", function() {
            selContract.value = "";
            selFunction.value = "";
            renderGrid(allJobs);
        });
        // Filtre live au changement de select
        selContract.addEventListener("change", function() {
            renderGrid(getFilteredJobs());
        });
        selFunction.addEventListener("change", function() {
            renderGrid(getFilteredJobs());
        });
        // ---------- Modale ----------
        function setMetaItem(id, text) {
            var el = document.getElementById(id);
            if (!el) return;
            var span = el.querySelector("span");
            if (!span) return;
            if (text) {
                span.textContent = text;
                el.classList.remove("hidden");
            } else el.classList.add("hidden");
        }
        function setSectionContent(wrapperId, contentId, html) {
            var wrapper = document.getElementById(wrapperId);
            var content = document.getElementById(contentId);
            if (!wrapper || !content) return;
            if (html && html.trim()) {
                content.innerHTML = html;
                wrapper.classList.remove("hidden");
            } else wrapper.classList.add("hidden");
        }
        function toYouTubeEmbed(url) {
            if (!url) return "";
            // youtu.be/ID
            var short = url.match(/youtu\.be\/([\w-]+)/);
            if (short) return "https://www.youtube.com/embed/" + short[1];
            // youtube.com/watch?v=ID
            var long = url.match(/[?&]v=([\w-]+)/);
            if (long) return "https://www.youtube.com/embed/" + long[1];
            return "";
        }
        function openModal(job) {
            // Titre
            document.getElementById("jobs-modal-title").textContent = job.title || "";
            // Logo
            var logoWrapper = document.getElementById("jobs-modal-logo-wrapper");
            var logoImg = document.getElementById("jobs-modal-logo");
            if (job.logo) {
                logoImg.src = job.logo;
                logoImg.alt = job.company || "";
                logoWrapper.classList.remove("hidden");
            } else logoWrapper.classList.add("hidden");
            // Meta
            setMetaItem("jobs-modal-contract", job.contract_type);
            setMetaItem("jobs-modal-location", job.location);
            setMetaItem("jobs-modal-company", job.company);
            setMetaItem("jobs-modal-function", job["function"]);
            // Vidéo YouTube
            var videoWrapper = document.getElementById("jobs-modal-video-wrapper");
            var videoIframe = document.getElementById("jobs-modal-video");
            var embedUrl = toYouTubeEmbed(job.url_video || "");
            if (embedUrl && videoWrapper && videoIframe) {
                videoIframe.src = embedUrl;
                videoWrapper.classList.remove("hidden");
            } else if (videoWrapper && videoIframe) {
                videoIframe.src = "";
                videoWrapper.classList.add("hidden");
            }
            // Contenus
            setSectionContent("jobs-modal-desc-wrapper", "jobs-modal-desc", job.position_description || job.description || "");
            setSectionContent("jobs-modal-req-wrapper", "jobs-modal-req", job.requirements_description || "");
            setSectionContent("jobs-modal-company-desc-wrapper", "jobs-modal-company-desc", job.company_description || "");
            // Date
            var dateEl = document.getElementById("jobs-modal-date");
            if (job.published) {
                dateEl.textContent = "Date de publication : " + formatDisplayDate(job.published);
                dateEl.classList.remove("hidden");
            } else dateEl.classList.add("hidden");
            // Lien Postuler
            var applyLink = document.getElementById("jobs-modal-apply");
            applyLink.href = job.url || "#";
            // Afficher
            overlay.classList.remove("hidden");
            document.body.style.overflow = "hidden";
            // Scroll to top de la modale
            var panel = document.getElementById("jobs-modal-panel");
            if (panel) panel.scrollTop = 0;
            overlay.scrollTop = 0;
        }
        function closeModal() {
            overlay.classList.add("hidden");
            document.body.style.overflow = "";
            // Stopper la vidéo en vidant le src
            var videoIframe = document.getElementById("jobs-modal-video");
            if (videoIframe) videoIframe.src = "";
        }
        closeBtn.addEventListener("click", closeModal);
        overlay.addEventListener("click", function(e) {
            if (e.target === overlay) closeModal();
        });
        document.addEventListener("keydown", function(e) {
            if (e.key === "Escape") closeModal();
        });
        // ---------- Rendu initial ----------
        renderGrid(allJobs);
    });
})();

})();
//# sourceMappingURL=listing-jobs.js.map
